import React from 'react';
import { GenericDropdown } from '../..';
import { Field } from 'react-final-form';
import './TableFilter.scss';
import { labelsSelector } from '@trip-ux/react-containers';
import { useSelector } from 'react-redux';
import { ReduxStore } from '@trip-ux/redux-store';
import { get } from 'lodash';
import { useTranslation } from '../translationContext';

const miscSelector = (store: ReduxStore) => {
  return get(labelsSelector(store), 'user_info.misc', {});
};

const TableFilterDropdown = ({ field, onChange, options, optionsLabelSelector }) => {
  const { t } = useTranslation();
  const miscLabels = useSelector(miscSelector);
  const { language } = useSelector((store: ReduxStore) => ({
    language: get(store, 'config.locale')
  }));

  const dropDownOptions = miscLabels[optionsLabelSelector] || options;

  return (
    <Field
      id={`dropdown-${field}`}
      name={field}
      component={GenericDropdown}
      className={'table-filter-dropdown'}
      options={dropDownOptions}
      placeholder={t(`tablefilter.defaultplaceholder.${field}`)}
      labels={t('tablefilter.defaultplaceholder')}
      ariaLabel={t(`tablefilter.defaultplaceholder.${field}`)}
      forwardRef={true}
      language={language}
      inputOnChange={onChange}
    />
  );
};

export default TableFilterDropdown;
